// Requests that are not a person's visit: a prefetch (Next's router, or the browser's speculative loading) and a known
// crawler or link-preview bot. The entry source (entry-source.js) and the visitor id (visitor-id.js) skip both. No
// browser dependencies: the middleware imports it.

export function isLandingPrefetch(headers) {
  return (
    headers.has('next-router-prefetch') ||
    headers.has('next-router-segment-prefetch') ||
    /prefetch/i.test(
      `${headers.get('purpose') || ''} ${headers.get('sec-purpose') || ''}`,
    )
  )
}

export function isKnownLandingBot(headers) {
  return /Googlebot|bingbot|DuckDuckBot|Applebot|YandexBot|Baiduspider|GPTBot|OAI-SearchBot|ChatGPT-User|ClaudeBot|PerplexityBot|facebookexternalhit|Facebot|Twitterbot|LinkedInBot|Slackbot|Discordbot|TelegramBot|WhatsApp|HeadlessChrome|Lighthouse/i.test(
    headers.get('user-agent') || '',
  )
}
